import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const expensify = defineConnector({
  identifier: "expensify",
  name: "Expensify",
  tagLine: "Expense management",
  logo,
  protocol: "http",
  tags: ["productivity", "data"],
  defaultUrlPattern: () => "https://integrations\\.expensify\\.com/.*",
  auth: customAuth("expensify"),
  steps: [
    {
      title: "Generate Expensify integration credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In Expensify, open the integrations tools page to generate your `partnerUserID` and `partnerUserSecret` credentials for the Integration Server.",
        },
      ],
    },
    {
      title: "Enter your Expensify details",
      items: [
        {
          kind: "input",
          label: "Partner user ID",
          required: true,
          target: { kind: "configuration", field: "partnerUserId" },
        },
        {
          kind: "input",
          label: "Partner user secret",
          required: true,
          target: { kind: "secrets", field: "partnerUserSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://integrations.expensify.com/Integration-Server/ExpensifyIntegrations",
      method: "POST",
      body: new URLSearchParams({
        requestJobDescription: JSON.stringify({
          type: "get",
          inputSettings: {
            type: "policyList",
          },
        }),
      }).toString(),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      expectedStatus: 200,
    }),
  },
});
